
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('HOME_LAST_ARTICLES').plugin(axiosPlugin, {template: "array"});

let fetchLastArticlesAction = redux.fetchActionGet();

export const fetchLastArticles = () => fetchLastArticlesAction(`/features/articles`);

export const homeLastArticles = redux.reducer();